import { api } from './client'

export const listKBDocs = (pid) =>
  api.get(`/kb/programs/${pid}`).then((r) => r.data)
export const uploadKBDoc = (pid, file) => {
  const fd = new FormData()
  fd.append('file', file)
  return api
    .post(`/kb/programs/${pid}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => r.data)
}
export const deleteKBDoc = (pid, docId) =>
  api.delete(`/kb/programs/${pid}/${docId}`).then((r) => r.data)
